import { useState, useEffect, useLayoutEffect } from "react"

const useIsomorphicLayoutEffect =
  typeof window !== "undefined" ? useLayoutEffect : useEffect

const useIsSsr = ({ beforePaint = false } = {}) => {
  // we always start off in "SSR mode", to ensure our initial browser render
  // matches the SSR render
  const [isSsr, setIsSsr] = useState(true)

  useIsomorphicLayoutEffect(() => {
    if (!beforePaint) return undefined

    setIsSsr(false)
    return undefined
  }, [beforePaint])

  useEffect(() => {
    if (beforePaint) return undefined

    // `useEffect` never runs on the server, so we must be on the client if
    // we hit this block
    setIsSsr(false)
    return undefined
  }, [beforePaint])

  return isSsr
}

export default useIsSsr
